import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './FAQ.css';

const faqData = [
  {
    question: "What is Film Revival NYC?",
    answer: "Film Revival NYC is a free online guide that aggregates showtimes for revival, repertory, and classic film screenings across New York City theaters. We pull together schedules from over 20 independent cinemas so you can find 35mm and classic film screenings in one place."
  },
  {
    question: "Where can I watch 35mm films in NYC?",
    answer: "New York City has many theaters that regularly screen 35mm film prints. Top venues include Film Forum, Metrograph, Quad Cinema, Anthology Film Archives, Roxy Cinema, Nitehawk Cinema (Williamsburg and Prospect Park), BAM Rose Cinemas, and Museum of the Moving Image. Use our filter to show only 35mm screenings across all theaters."
  },
  {
    question: "What theaters in NYC show classic and repertory films?",
    answer: "NYC's best repertory theaters include Film Forum (West Village), Metrograph (Lower East Side), Quad Cinema (Greenwich Village), Anthology Film Archives (East Village), BAM Rose Cinemas (Brooklyn), Roxy Cinema (Tribeca), Museum of the Moving Image (Queens), Museum of Modern Art/MoMA (Midtown), IFC Center (Greenwich Village), and Nitehawk Cinema locations in Williamsburg and Prospect Park. We also cover AMC and Regal locations across the city for mainstream and special event screenings."
  },
  {
    question: "How often is the film schedule updated?",
    answer: "Film Revival NYC updates showtimes daily. We pull data from theater schedules automatically, so you'll always see the most current listings. Schedules typically show films up to 90 days in advance when available."
  },
  {
    question: "What's playing at repertory theaters this week?",
    answer: "Use our List View to see what's playing today or this week at all NYC repertory theaters. You can filter by specific theater, neighborhood (Brooklyn, Lower Manhattan, Midtown, Queens, etc.), or by 35mm screenings. Click on any film title to see all upcoming showtimes across all theaters."
  },
  {
    question: "Is Film Revival NYC free to use?",
    answer: "Yes, Film Revival NYC is completely free. We're passionate about repertory cinema and want to make it easy for film lovers to discover classic and revival screenings across New York City."
  },
  {
    question: "How can I buy tickets to a screening?",
    answer: "Click on any film to see its showtimes, then click the 'Tickets' button next to any showtime. This will take you directly to the theater's ticketing page for that screening. You can also add screenings to your Google Calendar with one click."
  }
];

// Generate FAQ schema for structured data
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqData.map(item => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer
    }
  }))
};

function FAQ() {
  return (
    <div className="faq-container">
      <Helmet>
        <title>FAQ | Film Revival NYC - Revival & Repertory Cinema Guide</title>
        <meta
          name="description"
          content="Frequently asked questions about Film Revival NYC, 35mm film screenings, repertory theaters, and classic cinema in New York City."
        />
        <meta property="og:title" content="FAQ | Film Revival NYC" />
        <meta property="og:description" content="Frequently asked questions about Film Revival NYC, 35mm film screenings, repertory theaters, and classic cinema in New York City." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://filmrevivalnyc.com/faq" />
        <meta property="og:image" content="https://filmrevivalnyc.com/FILM_REVIVAL_NY_OG.jpg" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="FAQ | Film Revival NYC" />
        <meta name="twitter:description" content="Frequently asked questions about Film Revival NYC, 35mm film screenings, repertory theaters, and classic cinema in New York City." />
        <meta name="twitter:image" content="https://filmrevivalnyc.com/FILM_REVIVAL_NY_OG.jpg" />
        <link rel="canonical" href="https://filmrevivalnyc.com/faq" />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <header className="faq-header">
        <Link to="/" className="back-link">← Back to Showtimes</Link>
        <h1>Frequently Asked Questions</h1>
        <p className="faq-tagline">Everything you need to know about revival cinema in NYC</p>
      </header>

      <main className="faq-content">
        {faqData.map((item, index) => (
          <article key={index} className="faq-item">
            <h2 className="faq-question">{item.question}</h2>
            <p className="faq-answer">{item.answer}</p>
          </article>
        ))}
      </main>

      <footer className="faq-footer">
        <p>
          Have another question? Contact us at{' '}
          <a href="mailto:filmrevivalnyc@gmail.com">filmrevivalnyc@gmail.com</a>
        </p>
        <Link to="/" className="back-link">← Back to Showtimes</Link>
      </footer>
    </div>
  );
}

export default FAQ;

